export const regex: any = {
  somenteLetrasEhEspacos: '[\\sa-zA-Z]+',
  somenteLetrasNumerosEhEspacos: '[\\sa-zA-Z\\d]+',
  somenteNumeros: '^[0-9]*$',
  somenteLetrasEhNumeros: '[a-zA-Z0-9]+',
  somenteLetrasNumerosVirgulas: '^[a-zA-Z0-9, ]+$'
}
